import * as ss from 'superstruct';
import { Id } from './types';

export const DashboardResource = ss.object({
  id: Id,
  /** Title of this dashboard. */
  title: ss.string(),
  /**
   * Path to the dashboard URL, which is proxied by
   *
   * `https://platform.goarrowsup.com/dashboards`
   *
   * Path should be in the format of `/my-dash`, which
   * will generate a full URL of:
   *
   * `https://platform.goarrowsup.com/dashboards/my-dash`
   */
  path: ss.string(),
});

export type DashboardResource = ss.Infer<typeof DashboardResource>;
